import BecomeInstructorForm from "@/components/become-instructor/BecomeInstructorForm";
import Layout from "../components/Layout";
import { motion } from "framer-motion";
import Image from "next/image";
import { useRouter } from "next/router";
import Head from "next/head";
import Breadcrumb from "@/components/BreadCrumb";

type SocialMediaHandle = {
  slug: string;
  leadingText: string;
  iconImage: string;
};

const info = [
  {
    img: "/becomeInstructor/TeacherStudent.svg",
    title: "The #1 platform to monetise your expertise!",
    desc: "Launch Live Cohort Based Courses that attract lakhs from around the world",
  },
  {
    img: "/becomeInstructor/AstrolearnGroupVideo.svg",
    title: "You focus on the teaching,We do the boring stuff",
    desc: "Wow your learners with great teaching while we take care of Marketing, Operations, Finance, Design, and everything else!",
  },
  {
    img: "/becomeInstructor/AstrolearnSeminar.svg",
    title: "We handpick great teachers and make them legendary!",
    desc: "We only work with the very best teachers & help scale their impact & earnings in a record breaking time",
  },
];

export default function becomeInstructor() {
  const router = useRouter();
  return (
    <>
      <Head>
        <title>
          Become an Instructor | Teach Astrology Online with AstroLearn
        </title>
        <meta
          name="description"
          content="Share your expertise and teach astrology online with AstroLearn. Focus on teaching while we handle marketing, operations, and more. Join us today!"
        />
      </Head>

      <Layout childClassName="flex flex-col justify-center items-center text-center text-white pt-4">
        <Breadcrumb classNames="absolute top-20 left-4 lg:left-20" />
        <div className="flex flex-col md:bg-white md:w-full md:py-16 md:flex-row items-center mt-9 text-black justify-center md:px-[80px]">
          <div className="flex flex-col justify-center items-center md:flex-row">
            <Image
              src="/becomeInstructor/TeacherStudent.svg"
              height={198}
              width={298}
              alt="decorative image"
              className="md:hidden"
            />
            <div className="flex flex-col items-center justify-center md:px-[80px] md:items-start">
              <span className="text-[24px] mt-[20px] font-[600] font-lato text-center px-[80px] md:text-[40px] md:font-[500] md:text-left md:px-0">
                Become an Instructor and work with Us{" "}
              </span>
              <p className="text-[16px] font-[300] font-lato px-[14px] leading-[22px] mt-[10px] md:text-left">
                You get to make a impact on hundreds of students and change your
                own during the process
              </p>
              <button
                onClick={() => {
                  router.replace(`/become-an-instructor#form`);
                }}
                className="bg-black hover:bg-black/85 text-white focus:text-white hover:text-white font-lato font-semibold px-6 py-3 mt-4 md:px-20 md:py-5 md:text-[22px]"
              >
                Get Started
              </button>
            </div>
            <Image
              src="/becomeInstructor/TeacherStudent.svg"
              height={396}
              width={596}
              alt=""
              className=" hidden md:block pr-[80px]"
            />
          </div>
        </div>
        <div className="hidden md:flex md:flex-col md:text-black md:mt-[78px] md:mb-[64px]">
          <span className="text-[40px] font-[500] font-lato">
            All The benefits of Working With Us
          </span>
          <span className="text-[22px] font-[400] font-lato mt-[8px]">
            You take care of the studies, We take care of the rest
          </span>
        </div>
        <div className="flex flex-col md:flex-row md:px-[81px] md:justify-between">
          {info &&
            info.map((data: any, index) => (
              <motion.div
                key={index}
                className="w-full flex flex-row items-center justify-center"
                initial={{ opacity: 0, translateY: 100 }}
                whileInView={{ opacity: 1, translateY: 0 }}
                transition={{ duration: 0.4, type: "tween" }}
              >
                <section className="flex flex-col mt-[40px] md:mt-[0] !mx-[37px] md:h-full text-black bg-white items-center rounded-[14px] justify-center py-[32px]">
                  <Image src={data?.img} height={148} width={222} alt="" />
                  <div className="flex flex-col justify-center text-center items-center">
                    <p className="text-[24px] font-[600] font-lato px-[26px] ">
                      {data?.title}
                    </p>
                    <p className="font-lato text-[16px] font-[300] px-[39px] mt-[16px] md:min-h-[100px]">
                      {data?.desc}
                    </p>
                  </div>
                </section>
              </motion.div>
            ))}
        </div>
        <section
          id="form"
          className=" text-black mt-[40px] flex flex-col w-full px-6 md:items-center md:justify-center"
        >
          <p className="text-[24px] font-[500] font-lato md:text-[40px] md:font-[500]">
            Please Enter Your Details
          </p>
          <p className="text-[18px] font-[300] leading-[22px] font-lato mt-[8px] px-[40px] md:text-[22px] md:font-[300]">
            Join one of the worlds largest online learning marketplace{" "}
          </p>

          <BecomeInstructorForm />
        </section>
      </Layout>
    </>
  );
}
